import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TaskView from "../common/TaskView";
import { AcousticTask, AcousticTaskDefinition, SubTask, SubTaskDefinition } from "../common/models";
import { randomUUID } from "../../../utils";
import englishHsData from './HarvardSentences.json';
import spanishHsData from './HarvardSentences-es-419.json';
import { Typography } from "@mui/material";

const Definition: AcousticTaskDefinition = {
  name: "Harvard Sentences",
  title: "Harvard Sentences",
  description: "Please read the following sentences out loud in your typical voice.",
  cohort: 'generic',
  type: 'acoustic-task',
  estimatedCompletionTime: '1:30',
  subTaskDefinitions: [],
}

export const HarvardSentencesDefinition = Definition;

const createSubTaskDefinitions = ({ name, sentences }: { name: string, sentences: string[] }): SubTaskDefinition[] => {
  return sentences.map((sentence, index) => ({
    name: `Harvard Sentences-${name}-${index + 1}`,
    title: "",
    instructions: <Typography variant="h5" component='div'>{sentence}</Typography>,
    profileName: 'speech'
  }));
};

export const HarvardSentences =  ({onCompletion}: {onCompletion: () => void}) => {
  const { i18n } = useTranslation();

  // Map is defined once for performance
  const HARVARD_SENTENCES_MAP: { [key: string]: { name: string; sentences: string[]; }[] } = {
    en: englishHsData,
    'es-419': spanishHsData
  };

  const getHarvardSentencesForLanguage = (language: string) => {
    return HARVARD_SENTENCES_MAP[language] || englishHsData;
  };

  const getSubTasks = (): SubTask[] => {
    const hsData = getHarvardSentencesForLanguage(i18n.language);
    const index1 = Math.floor(Math.random() * hsData.length);
    const task1 = createSubTaskDefinitions(hsData[index1]);

    const filtered = hsData.filter((_, i) => i !== index1);
    const task2 = createSubTaskDefinitions(filtered[Math.floor(Math.random() * filtered.length)]);

    const selectedSubTasks = [...task1, ...task2];
    return selectedSubTasks.map((definition) => ({ ...definition, id: randomUUID() }));
  };

  const [task, _setTask] = useState<AcousticTask>(() => ({
    ...Definition,
    id: randomUUID(),
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'pending',
    subTasks: getSubTasks()
  }));

  const handleOnCompletion = () => {
    console.log("Audio task completed", task.title);
    onCompletion();
  }

  return (
    <div>
      <TaskView
        task={task}
        onCompletion={handleOnCompletion}
        />
    </div>
  );
}

